<template>
  <b-form-group :id="companyPrefixGroupId" :state="prefixState">
    <label for="company-prefix-input" class="form__label input-label">Company URL Prefix</label>
    <b-input-group>
      <b-form-input
        id="company-prefix-input"
        type="text"
        :state="prefixState"
        v-model.trim="$v.prefix.$model"
        class="sing-up-input d-flex align-items-center"
        placeholder="Enter company URL prefix"
        autocomplete="off"
      />

      <b-input-group-append>
        <b-input-group-text>
          easyagency.io
          <span
            class="material-icons ml-2 mt-1"
            title="Enter a prefix for your company's domain: “prefix.easyagency.com”"
            v-b-tooltip.html="{ variant: 'base', container: companyPrefixGroupId }"
          >info_outline</span>
        </b-input-group-text>
      </b-input-group-append>
    </b-input-group>

    <template v-slot:invalid-feedback>
      <div v-if="!$v.prefix.required">{{ VALIDATION_MESSAGES.common.required }}</div>
      <div v-else-if="!$v.prefix.minLength">{{ VALIDATION_MESSAGES.common.minLength($v.prefix.$params.minLength.min) }}</div>
      <div v-else-if="!$v.prefix.maxLength">{{ VALIDATION_MESSAGES.common.maxLength($v.prefix.$params.maxLength.max) }}</div>
      <div
        v-else-if="!$v.prefix.companyURLPrefixAllowedCharacters"
        v-html="VALIDATION_MESSAGES.companyPrefixURL.allowedCharacters"
      />
      <div v-else v-for="(error, index) in serverErrors" :key="index">
        {{ error }}
      </div>
    </template>
  </b-form-group>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength, minLength } from 'vuelidate/lib/validators'
import { companyURLPrefixAllowedCharacters } from '@utils/validators'

const companyUrlPrefixMinLength = 2
const companyUrlPrefixMaxLength = 20

export default {
  name: 'CompanyUrlPrefixField',
  mixins: [validationMixin],
  props: {
    value: String,
    companyPrefixGroupId: {
      type: String,
      required: true
    },
    hideValidationErrors: {
      type: Boolean,
      required: true
    },
    serverErrors: [Array, null]
  },
  data () {
    return {
      prefix: ''
    }
  },
  validations: {
    prefix: {
      required,
      minLength: minLength(companyUrlPrefixMinLength),
      maxLength: maxLength(companyUrlPrefixMaxLength),
      companyURLPrefixAllowedCharacters
    }
  },
  computed: {
    prefixState () {
      return !this.hideValidationErrors && (this.$v.prefix.$error || this.serverErrors) ? false : null
    }
  },
  created () {
    const prefix = this.$cookies.get('tenant_prefix')
    if (prefix) {
      this.prefix = prefix
    }
  }
}
</script>
